import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import Button from '@/components/Button';
import Image from '@/components/Image';
import { ProcessList } from '@/components/ProcessList';
import PageComponent from '@/components/PageComponent';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import centerActObj1 from '@/assets/img/about-us/supporters_center_icon1@2x.png';
import centerActObj1M from '@/assets/img/about-us/supporters_center_icon1M@2x.png';
import centerActObj2 from '@/assets/img/about-us/supporters_center_icon2@2x.png';
import centerActObj2M from '@/assets/img/about-us/supporters_center_icon2M@2x.png';
import centerActObj3 from '@/assets/img/about-us/supporters_center_icon3@2x.png';
import centerActObj3M from '@/assets/img/about-us/supporters_center_icon3M@2x.png';
import centerCaseImg1 from '@/assets/img/about-us/supporters_center_img1@2x.jpg';
import centerCaseImg2 from '@/assets/img/about-us/supporters_center_img2@2x.jpg';
import centerCaseImg3 from '@/assets/img/about-us/supporters_center_img3@2x.jpg';
import { PageProps } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

const centerData = [
  {
    id: 1,
    img: centerActObj1,
    imgM: centerActObj1M,
    title: `<strong>아너스클럽 회원</strong> <br />
            <strong>발굴 및 관계 <br class="pc-hide" /> 관리</strong>를 통해`,
    desc: [
      {
        dec: `
          지역사회 내 나눔의 <br />
          선순환을 이끕니다.
        `,
      },
    ],
  },
  {
    id: 2,
    img: centerActObj2,
    imgM: centerActObj2M,
    title: `<strong>지역 기반 기업 <br class="pc-hide" /> 후원자와의</strong> <br />
            <strong>파트너십</strong>을 통해`,
    desc: [
      {
        dec: `
          지속가능한 사회공헌 <br class="pc-hide" /> 생태계를 <br class="m-hide" />
          조성합니다.
        `,
      },
    ],
  },
  {
    id: 3,
    img: centerActObj3,
    imgM: centerActObj3M,
    title: `<strong>지역 밀착형</strong> <br class="m-hide" />
            <strong>아동권리 <br class="pc-hide" /> 프로그램</strong>을 통해`,
    desc: [
      {
        dec: `
          아동의 삶에 실질적인 <br class="pc-hide" /> 변화를 <br class="m-hide" />
          만들어갑니다.
        `,
      },
    ],
  },
];
const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `지역후원센터`,
    tel: `051-501-0087`,
    email: `rfc@unicef.or.kr`,
  },
];
const brochureData = [
  {
    id: 1,
    icon: `share`,
    title: `E-book으로 보기`,
    link: `https://www.unicef.or.kr/data/upload/ebook/unicef-publications/supporters-club/`,
  },
  {
    id: 2,
    icon: `down`,
    title: `pdf 다운로드`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9zdXBwb3J0ZXJzX2NsdWI=&dispFileNm=supporters-club-brochure.pdf&svrFileNm=supporters-club-brochure.pdf`,
  },
];

const SectionActivities = styled(Section)`
  .process-ol {
    h3 {
      ${Tit} {
        font-weight: 400 !important;
      }
    }
    .img-wrap {
      height: 80px;
      .img-box {
        height: 100%;
        padding-top: 0;
        background-size: contain;
      }
    }

    ${breakpoint(`mobile`)} {
      .list-item {
        padding: 0 13px;
      }
    }
  }
`;
const SectionCase = styled(Section)`
  .case-wrap {
    display: flex;
    width: 100%;
    gap: 32px;
    align-items: stretch;
    justify-content: space-between;

    .box {
      flex: 1;
      border: 1px solid #e5e6e8;
      padding: 24px 24px 32px;
      text-align: center;

      .case-tit {
        margin: 20px 0 16px;
      }
      .case-desc {
        padding: 0 10px;
        line-height: 1.68;
        ${breakpoint(`tablet`)} {
          padding: 0;
        }
      }
    }

    ${breakpoint(`mobile`)} {
      flex-direction: column;

      .box {
        padding: 16px 17px 24px;

        .case-tit {
          margin: 16px 0;
        }
      }
    }
  }
`;

const BrochureWrap = styled.div`
  h4 {
    margin-bottom: 54px;
  }
  .btn-wrap {
    display: flex;
    gap: 30px;

    .col {
      flex: 1;
    }
  }
  ${breakpoint(`tablet`)} {
    h4 {
      margin-bottom: 32px;
    }
    .btn-wrap {
      flex-direction: column;
      gap: 16px;
    }
  }

  ${Button} {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    ${breakpoint(`mobile`)} {
      padding: 15px 24px;
    }
  }
`;

const SupportersCenter: FC<PageProps> = ({ location }) => (
  <>
    <Section className="by-sub-main-layout">
      <Container>
        <SectionHeader
          className="with-desc"
          css={`
            padding-bottom: 0 !important;
          `}
        >
          <h2>
            <Tit size="s1-5" weight="bold">
              유니세프 지역후원센터는
            </Tit>
          </h2>
          <p className="header-dec">
            <strong>유니세프 한국위원회 지역후원센터는</strong> 2006년 ‘유니세프
            부산사무소’로 처음 문은 연 이래,
            <br className="m-hide" />
            지역사회와의 지속적인 소통과 협력을 이어오고 있습니다. 유니세프의
            이념을 실현하며 충남권 이남 지역에서의 기부 문화를 활성화하고,
            <br className="m-hide" />
            지역 후원자들과 더욱 가까이에서 소통하기 위해 2025년
            ‘지역후원센터’로 새롭게 개편되었습니다.
          </p>
        </SectionHeader>
      </Container>
    </Section>

    <SectionActivities className="by-sub-main-layout" backgroundColor="#E2F0F6">
      <Container>
        <SectionHeader className="with-desc">
          <h2>
            <Tit size="s1-5" weight="bold">
              지역후원센터 활동
            </Tit>
          </h2>
        </SectionHeader>
        <ProcessList itemData={centerData} />
      </Container>
    </SectionActivities>

    <SectionCase className="by-sub-main-layout">
      <Container>
        <SectionHeader className="with-desc">
          <h2>
            <Tit size="s1-5" weight="bold">
              지역후원센터 활동사례
            </Tit>
          </h2>
        </SectionHeader>
        <div className="case-wrap">
          <div className="box">
            <div className="img">
              <img src={centerCaseImg1} alt="유니세프 자선골프대회" />
            </div>
            <div className="case-tit">
              <Tit size="s4" weight="bold" color="sky">
                유니세프 <br className="m-hide" />
                자선골프대회
              </Tit>
            </div>
            <p className="case-desc">
              유니세프 지역후원회와 함께 <br className="m-hide" />
              기금마련 자선 골프대회를 개최하여 <br className="m-hide" />
              지역사회 내 기부 네크워크를 형성하여 <br className="m-hide" />
              나눔의 선순환을 도모합니다.
            </p>
          </div>
          <div className="box">
            <div className="img">
              <img
                src={centerCaseImg2}
                alt="유니세프- 롯데자이언츠 사회공헌 협약"
              />
            </div>
            <div className="case-tit">
              <Tit size="s4" weight="bold" color="sky">
                유니세프- 롯데자이언츠 <br className="m-hide" />
                사회공헌 협약
              </Tit>
            </div>
            <p className="case-desc">
              롯데자이언츠는 2011년부터 지난 15년간
              유니세프와의 사회공헌 협약을 통해 아시아
              어린이 교육 지원 캠페인을 후원해 왔으며
              스포츠를 통한 나눔문화 확산에 많은
              기여를 하고 있습니다.
            </p>
          </div>
          <div className="box">
            <div className="img">
              <img
                src={centerCaseImg3}
                alt="다문화가정 어린이와 함께하는 예능발표회"
              />
            </div>
            <div className="case-tit">
              <Tit size="s4" weight="bold" color="sky">
                다문화가정 어린이와 <br className="m-hide" />
                함께하는 예능발표회
              </Tit>
            </div>
            <p className="case-desc">
              유니세프는 2011년부터 지역 내 다문화 가정
              아동과 함께 예능 발표회를 개최하고 있습니다.
              이를 통해 아동의 참여권을 실현하는 동시에,
              지역 사회의 다양성과 포용성을 키우며 모두가
              함께하는 문화를 만들어가고 있습니다.
            </p>
          </div>
        </div>
      </Container>
    </SectionCase>

    <BrochureWrap>
      <Container>
        <h4>
          <Tit size="s2">지역후원센터 소개서</Tit>
        </h4>
        <div className="btn-wrap">
          {brochureData.map((row) => (
            <div className="col" key={row.id}>
              <Button
                ico={row.icon}
                outline
                full
                onClick={() => window.open(row.link)}
              >
                <span className="ico">{row.title}</span>
              </Button>
            </div>
          ))}
        </div>
      </Container>
    </BrochureWrap>

    <Section className="by-sub-main-layout">
      <Container>
        <ContactUs itemData={contactData} />
      </Container>
    </Section>
  </>
);
export default SupportersCenter;
